import { z } from 'zod';

/**
 * Global zod error map. Pins validation wording close to the legacy joi
 * messages so the visible form errors stay stable after the joi -> zod swap.
 *
 * Messages intentionally omit the field name; `Validator` reconstructs the
 * `"Human Field" message` form from `issue.path`.
 */
z.config({
  customError(issue) {
    switch (issue.code) {
      case 'invalid_format':
        if (issue.format === 'email') {
          return 'must be a valid email';
        }
        if (issue.format === 'url') {
          return 'must be a valid URL';
        }
        return undefined;

      case 'invalid_type':
        if (issue.input === undefined) {
          return 'is required';
        }
        if (issue.expected === 'number') {
          return 'must be a number';
        }
        if (issue.expected === 'date') {
          return 'must be a valid date';
        }
        return `must be a ${issue.expected}`;

      case 'invalid_value':
        return 'must be one of the allowed values';

      case 'too_big':
        if (issue.origin === 'string') {
          return `length must be less than or equal to ${issue.maximum} characters long`;
        }
        return issue.inclusive
          ? `must be less than or equal to ${issue.maximum}`
          : `must be less than ${issue.maximum}`;

      case 'too_small':
        if (issue.origin === 'string') {
          return Number(issue.minimum) <= 1
            ? 'is not allowed to be empty'
            : `length must be at least ${issue.minimum} characters long`;
        }
        if (issue.origin === 'array') {
          return `must contain at least ${issue.minimum} items`;
        }
        return issue.inclusive
          ? `must be greater than or equal to ${issue.minimum}`
          : `must be greater than ${issue.minimum}`;

      default:
        return undefined;
    }
  },
});
